function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M18 24h2v2h-2v-2zm-7.896-6h13.748a2 2 0 0 0 1.993-2.188 2.466 2.466 0 0 0-2.646-2.27 25.44 25.44 0 0 0-3.003.439C14.16 15.188 9.28 13.51 8.91 8.87c-1.237.991-2.104 2.298-2.615 3.942A4 4 0 0 0 10.104 18H10v2h11v-2H10.104zm-4.449.015a6 6 0 0 1-1.27-5.795c.862-2.774 2.598-4.83 5.168-6.114l1.756-.879-.323 1.937c-.719 4.316 3.119 5.995 8.818 4.855a27.408 27.408 0 0 1 3.242-.472A4.466 4.466 0 0 1 27.852 16a3.98 3.98 0 0 1-.648 2.184 4.002 4.002 0 0 1 2.12 6.04A4.002 4.002 0 0 1 28 32H4a4 4 0 0 1-1.325-7.775 4 4 0 0 1 2.98-6.21zM10.102 20H6a2 2 0 1 0 0 4h20a2 2 0 1 0 0-4H10.102zM28 26H4a2 2 0 1 0 0 4h24a2 2 0 1 0 0-4zm-12-2v2h10v-2H16zm-.707-22.293A1 1 0 0 1 16.707.293c1.724 1.724 1.724 3.69 0 5.414-.943.943-.943 1.643 0 2.586a1 1 0 0 1-1.414 1.414c-1.724-1.724-1.724-3.69 0-5.414.943-.943.943-1.643 0-2.586zm5 0A1 1 0 0 1 21.707.293c1.724 1.724 1.724 3.69 0 5.414-.943.943-.943 1.643 0 2.586a1 1 0 0 1-1.414 1.414c-1.724-1.724-1.724-3.69 0-5.414.943-.943.943-1.643 0-2.586z"
});

var SvgPoop = function SvgPoop(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "c2ea46e47697946c2ab5851563d1fb21.svg";
export { SvgPoop as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/poop.svg
// module id = null
// module chunks = 